import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {ReviewerFilmService} from '../reviewer-film.service';


@Injectable()
export class UserFilmsResolver implements Resolve<any> {
	constructor(
		private reviewerFilmService: ReviewerFilmService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		console.log('UserFilmsResolver called    #1');

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			this.reviewerFilmService.getAvailableFilms()
				.then((filmIds: any) => {

					console.log('UserFilmsResolver called    #2');

					let userFilmsInfo = {
						availableFilmIds: filmIds,
						params: this.params
					};
					resolve(userFilmsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-films.resolver.ts